import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { LoadingSpinner } from 'yankees-react-utils';
import { useOktaQuery, Team } from '../../../../data';
import TippingReportPlayer from './TippingReportPlayer';

const TippingReport = ({ team }) => {
    const { t: translate } = useTranslation();
    const [catchingLineup, setCatchingLineup] = useState([]);
    const [pitchingLineup, setPitchingLineup] = useState([]);

    const [hasCatcherTippingNotes, setHasCatcherTippingNotes] = useState(0);
    const [hasPitcherTippingNotes, setHasPitcherTippingNotes] = useState(0);

    const { isFetching: loading1 } = useOktaQuery(['lineup-p', { teamid: team.TeamID }], (t) => Team.lineup(t, team.TeamID, false), {
        onSuccess: (data) => {
            setPitchingLineup(data.map((y) => y.Player));
        },
    });
    const { isFetching: loading2 } = useOktaQuery(['lineup-c', { teamid: team.TeamID }], (t) => Team.lineup(t, team.TeamID, true), {
        onSuccess: (data) => {
            setCatchingLineup(data.filter((x) => x?.Player?.PrimaryPosition === 2).map((y) => y.Player));
        },
    });

    const hasTipsCallbackCatchers = (count) => {
        setHasCatcherTippingNotes(hasCatcherTippingNotes + count);
    };

    const hasTipsCallbackPitchers = (count) => {
        setHasPitcherTippingNotes(hasPitcherTippingNotes + count);
    };

    if (loading1 || loading2) return <LoadingSpinner />;

    return (
        <div>
            <Row>
                <Col md={6}>
                    <h2>{translate('sections.opponent.tipping-report')}</h2>
                </Col>
                <Col md={6}>
                    <div className="flex float-end">
                        <span style={{ display: 'inline-block', padding: '5px', marginRight: '8px', backgroundColor: 'rgb(191,255,191)' }}>{translate('sections.opponent.player.confirmed')}</span>
                        <span style={{ display: 'inline-block', padding: '5px', marginRight: '8px', backgroundColor: 'rgb(255,255,170)' }}>{translate('sections.opponent.player.strong-monitor')}</span>
                        <span style={{ display: 'inline-block', padding: '5px', border: '1px solid black', backgroundColor: '#FFF' }}>{translate('sections.opponent.player.monitor')}</span>
                    </div>
                </Col>
            </Row>
            <hr />
            <Row key="pitchers">
                <Col md={12}>
                    <h2 className="mb-0">{translate('baseball.pitcher_other')}</h2>
                </Col>
            </Row>
            {pitchingLineup.map((plr) => <TippingReportPlayer key={plr.PlayerID} playerId={plr.PlayerID} player={plr} hasOneOrMoreTipsCallback={hasTipsCallbackPitchers} />)}
            <hr />
            <Row key="catchers" style={{ marginTop: '10px' }}>
                <Col md={12}>
                    <h2 className="mb-0">{translate('baseball.catcher_other')}</h2>
                </Col>
            </Row>
            {catchingLineup.map((plr) => <TippingReportPlayer key={plr.PlayerID} playerId={plr.PlayerID} player={plr} hasOneOrMoreTipsCallback={hasTipsCallbackCatchers} />)}
        </div>
    );
};

TippingReport.propTypes = {
    team: PropTypes.shape({
        LevelID: PropTypes.number,
        TeamID: PropTypes.number,
    }),
};
TippingReport.defaultProps = {
    team: {},
};

export default TippingReport;
